import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { NumericFormat } from "react-number-format";
import useFormattedLocalDate from "../../../../../hooks/useFormattedLocalDate";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "direct-money-form";

const DirectMoney = forwardRef(({ close, get, edit, Id }, ref) => {
  const formatDate = useFormattedLocalDate();

  const [call, setCall] = useState({
    amout: "",
    payment_date: undefined,
    refrence_number: "",
    following_number: "",
    card_number: "",
    payment_method: "",
    bank: "",
    description: "",
    student: Id,
  });

  const newGroup = useFetch({
    method: "POST",
    url: `management/directmoney/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const editMoney = useFetch({
    method: "PATCH",
    url: `management/directmoney/${edit}/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const getMoney = useFetch({
    method: "GET",
    url: `management/directmoney/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    // e.preventDefault();

    if (edit) {
      editMoney.reFetch();
    } else {
      newGroup.reFetch();
    }
  };
  useEffect(() => {
    newGroup.status === 201 && close();
    editMoney.status === 200 && close();
    setCall({
      amout: "",
      payment_date: "",
      refrence_number: "",
      following_number: "",
      card_number: "",
      payment_method: "",
      bank: "",
      description: "",
      student: Id,
    });
  }, [newGroup.status, editMoney.status]);

  const submitting = newGroup.loading || editMoney.loading;

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش پرداخت" : "پرداخت جدید"}
      subtitle="جزئیات تراکنش نقدی/کارتی"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={submitting}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {submitting ? "در حال ثبت…" : "ثبت تراکنش"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-lg text-sm"
      >
        <div>
          <NumericFormat
            customInput={TextField}
            thousandSeparator
            name="amout"
            label="مبلغ"
            value={call.amout}
            onValueChange={(e) => {
              setCall({ ...call, amout: e.value });
            }}
            error={!!errors?.amout}
            helperText={errors?.amout?.message || ""}
            fullWidth
            valueIsNumericString
          />
        </div>
        <div>
          <TextField
            name="following_number"
            type={"text"}
            value={call.following_number}
            label="شماره پیگیری"
            {...register("following_number", {
              required: "شماره پیگیری را وارد کنید",
            })}
            error={!!errors.following_number}
            helperText={
              errors.following_number ? errors.following_number.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, following_number: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <TextField
            name="refrence_number"
            type={"text"}
            value={call.refrence_number}
            label="شماره مرجع"
            {...register("refrence_number", {
              required: "شماره مرجع را وارد کنید",
            })}
            error={!!errors.refrence_number}
            helperText={
              errors.refrence_number ? errors.refrence_number.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, refrence_number: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <TextField
            name="card_number"
            type="text"
            value={call.card_number}
            label="چهار رقم آخر کارت"
            {...register("card_number", {
              required: "وارد کنید",
            })}
            error={!!errors.card_number}
            helperText={errors.card_number ? errors.card_number.message : ""}
            onChange={(e) => {
              setCall({ ...call, card_number: e.target.value.toString() });
            }}
            fullWidth
          />
        </div>
        <div>
          <TextField
            name="payment_method"
            value={call.payment_method}
            label="روش پرداخت"
            {...register("payment_method", {
              required: "روش پرداخت را وارد کنید",
            })}
            error={!!errors.payment_method}
            helperText={
              errors.payment_method ? errors.payment_method.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, payment_method: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <TextField
            name="bank"
            value={call.bank}
            label="بانک"
            {...register("bank", {
              required: "بانک را وارد کنید",
            })}
            error={!!errors.bank}
            helperText={errors.bank ? errors.bank.message : ""}
            onChange={(e) => {
              setCall({ ...call, bank: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <MobileDatePicker
            label="تاریخ"
            onChange={(e) => {
              const date = formatDate(e);
              setCall((prev) => ({
                ...prev,
                payment_date: date,
              }));
            }}
            value={call.payment_date ? new Date(call.payment_date) : null}
            views={["year", "month", "day"]}
            className="!text-6xl w-full"
            slotProps={{
              field: { shouldRespectLeadingZeros: true },
              toolbar: { hidden: true },
              tabs: { hidden: true },
            }}
          />
        </div>
        <div>
          <TextField
            name="description"
            value={call.description}
            label="توضیحات"
            {...register("description", {})}
            error={!!errors.description}
            helperText={errors.description ? errors.description.message : ""}
            onChange={(e) => {
              setCall({ ...call, description: e.target.value });
            }}
            fullWidth
          />
        </div>
      </form>
    </ModalShell>
  );
});

export default DirectMoney;
